import type { AnalyticsLinkRouter } from "replo-publisher-v1/src/trpc/routers/analyticsLink";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: analyticsLinkRouter,
  client: analyticsLinkClient,
  utils: analyticsLinkUtils,
  options: analyticsLinkOptions,
} = createTrpcRouterConfig<AnalyticsLinkRouter>({
  path: "analyticsLink",
  queryClient: getNamespacedQueryClient("analyticsLink"),
});

export {
  analyticsLinkClient,
  analyticsLinkRouter,
  analyticsLinkUtils,
  analyticsLinkOptions,
};
